// src/components/PrivateRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../authContext';

// Point this to your actual 2FA session-check endpoint
const check2FAUrl =
  process.env.NODE_ENV === 'development'
    ? 'http://127.0.0.1:5001/eyp-at/us-central1/check2FASession'
    : 'https://us-central1-YOUR_PROJECT_ID.cloudfunctions.net/check2FASession';

const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();

  // Track whether we're still checking 2FA
  const [loading, setLoading] = useState(true);
  // Whether the user has a valid 2FA session
  const [twoFaValid, setTwoFaValid] = useState(false);

  useEffect(() => {
    // If not logged in at all, skip 2FA check and let the code below handle redirect
    if (!currentUser) {
      setLoading(false);
      return;
    }
  }, [currentUser]);

   

  // 1) If not logged in, go to sign-in
  if (!currentUser) {
    return <Navigate to="/sign-in" />;
  }


  // 4) Otherwise, render protected content
  return children;
};

export default PrivateRoute;
